import React from 'react';
import './UniversalLoader.css';

const UniversalLoader = ({ message = "Loading...", size = "medium" }) => {
  return (
    <div className={`universal-loader ${size}`}>
      <div className="loader-container">
        <div className="gears-container">
          <div className="gear gear-1">
            <i className="fas fa-cog"></i>
          </div>
          <div className="gear gear-2">
            <i className="fas fa-cog"></i>
          </div>
          <div className="gear gear-3">
            <i className="fas fa-cog"></i>
          </div>
        </div>
        <div className="loader-text">
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
};

export default UniversalLoader;
